import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';
import { h, render } from 'preact';
import { StrictMode } from 'preact/compat';
import InspirationsRemovedModal from './InspirationsRemovedModal';

export const initInspirationsRemoved = () =>
    window.ikea.pubsub.subscribe(
        'LIST_AGENT/UNAVAILABLE_INSPIRATIONS_REMOVED',
        async (inspirationsRemovedQuantity: number) => {
            await Promise.all([fetchPhraseIfNeeded()]).then(() => {
                render(
                    <StrictMode>
                        <InspirationsRemovedModal
                            quantity={inspirationsRemovedQuantity}
                            destroy={() => {
                                render(null, document.getElementById('inspirations-removed') as HTMLElement);
                            }}
                        />
                    </StrictMode>,
                    document.getElementById('inspirations-removed') as HTMLElement
                );
            });
        }
    );
